import BFormInput from './form-input';
import { installFactory } from '../../utils/plugins';
var components = {
  BFormInput: BFormInput,
  BInput: BFormInput
};
export { BFormInput };
export default {
  install: installFactory({
    components: components
  })
};